// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_CUF24","breadcrumbs":"index_breadcrumbs_Yh0-u"};